import React from 'react';
import Link from 'next/link';
import Icon from '@/components/ui/AppIcon';

const CTASection = () => {
  return (
    <section className="py-16 lg:py-24 bg-gradient-to-br from-primary to-secondary relative overflow-hidden">
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-0 right-0 w-96 h-96 bg-white rounded-full blur-3xl"></div>
        <div className="absolute bottom-0 left-0 w-96 h-96 bg-white rounded-full blur-3xl"></div>
      </div>

      <div className="relative max-w-4xl mx-auto px-4 text-center space-y-8">
        <div className="inline-flex items-center space-x-2 px-4 py-2 bg-white/20 backdrop-blur-sm rounded-full">
          <Icon name="HeartIcon" size={20} variant="solid" className="text-white" />
          <span className="text-sm font-medium text-white">Start Your Journey Today</span>
        </div>

        <h2 className="text-3xl lg:text-5xl font-headline font-semibold text-white leading-tight">
          Ready to Welcome a New Family Member?
        </h2>

        <p className="text-lg lg:text-xl text-white/90 max-w-2xl mx-auto">
          Join thousands of families who have found their perfect companion through Exotic and Domestic. Your future best friend is waiting.
        </p>

        <div className="flex flex-col sm:flex-row gap-4 justify-center pt-4">
          <Link
            href="/pet-discovery"
            className="inline-flex items-center justify-center space-x-2 px-8 py-4 bg-white text-primary font-headline font-semibold rounded-lg hover:shadow-elevated hover:-translate-y-0.5 transition-all duration-300"
          >
            <Icon name="MagnifyingGlassIcon" size={20} variant="outline" />
            <span>Browse Available Pets</span>
          </Link>

          <Link
            href="/adoption-process"
            className="inline-flex items-center justify-center space-x-2 px-8 py-4 bg-transparent text-white font-headline font-semibold rounded-lg border-2 border-white hover:bg-white hover:text-primary transition-all duration-300"
          >
            <Icon name="ClipboardDocumentCheckIcon" size={20} variant="outline" />
            <span>Learn About Adoption</span>
          </Link>
        </div>

        <div className="pt-8 flex flex-col sm:flex-row items-center justify-center gap-8 text-white">
          <div className="flex items-center space-x-2">
            <Icon name="CheckCircleIcon" size={24} variant="solid" />
            <span className="font-medium">Verified Shelters</span>
          </div>
          <div className="flex items-center space-x-2">
            <Icon name="CheckCircleIcon" size={24} variant="solid" />
            <span className="font-medium">Expert Support</span>
          </div>
          <div className="flex items-center space-x-2">
            <Icon name="CheckCircleIcon" size={24} variant="solid" />
            <span className="font-medium">Lifetime Resources</span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;